import { call } from '../core'

export enum ContentType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
}

export interface IContentParams {
  type: ContentType
  data: string
}

export function shareContent(params: IContentParams) {
  call('finShareContent', params)
}
